import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue, KeyValueDefault } from '@/main/models/common';

// Redux
import { saveIntegrationQueueStatus } from './index';

// Api's
import { integrationQueueApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getIntegrationQueueStatusSaga() {
  try {
    const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(
      integrationQueueApi.getDomainStatus
    );

    if (response.data.result) {
      yield put(saveIntegrationQueueStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveIntegrationQueueStatus(null, true, resultError.messagesDataError));
    }
  }
}

